export default __webpack_public_path__ + "static/media/bg.685862ed.png";